export enum FileUploaderType {
  imgJPEG = 'image/jpeg',
  imgPNG = 'image/png',
  imgGIF = 'image/gif',
  imgWEBP = 'image/webp',
  imgSVG = 'image/svg',
  videoQuickTime = 'video/quicktime',
  videoMP4 = 'video/mp4',
}
